import Box from "@mui/material/Box";
import { forwardRef } from "react";
import { useIntl } from "react-intl";

import { PlayerFrame } from "./player-frame";

type PlayerIframeProps = {
  src?: string;
};

export const PlayerIframe = forwardRef(({ src }: PlayerIframeProps, ref) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <PlayerFrame>
        <Box
          title={formatMessage({ id: "show_player" })}
          src={src}
          allow={"autoplay; fullscreen; picture-in-picture"}
          allowFullScreen
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "none",
            background: "rgba(255, 255, 255, 0.13)",
            borderRadius: 2,
          }}
          component="iframe"
          ref={ref}
        />
      </PlayerFrame>
    </>
  );
});
